<script setup lang="ts">
import LandingTitleLayout from '../LandingTitleLayout.vue';
import AdvantageCard from '../AdvantageCard.vue';
import { APP_NAME } from '@glow/shared/lib/constants';

const { staticUrl } = useRuntimeConfig().public;
const isExpanded = ref(false);
</script>

<template>
  <div id="differences" class="container">
    <LandingTitleLayout>
      <template #title>
        Найди в {{ APP_NAME }} то,
        <span>чего нет у остальных</span>
      </template>
    </LandingTitleLayout>

    <div class="differences__grid">
      <AdvantageCard
        :icon-src="`${staticUrl}/landing/forwhom5.png`"
        title="Бесплатное пользование"
        color="#f1f1ff"
      >
        Не трать свои деньги на рекламные показы, чтобы клиенты тебя увидели.
        Размести портфолио за 0 руб.
      </AdvantageCard>

      <AdvantageCard
        :icon-src="`${staticUrl}/landing/difference7.png`"
        title="Беспокоимся о времени"
        color="#f7f7f8"
      >
        Настройка рекламы больше не твои проблемы. Простая регистрация за 5
        минут
      </AdvantageCard>

      <AdvantageCard
        :icon-src="`${staticUrl}/landing/difference8.png`"
        title="С заботой о клиенте"
        color="#f1f6ff"
      >
        Служба поддержки поможет с любым вопросом и не оставит без внимания даже
        необоснованно плохие отзывы
      </AdvantageCard>

      <AdvantageCard
        class="differences__long-block-1"
        :icon-src="`${staticUrl}/landing/why4.png`"
        title="Функциональный календарь"
        color="#f7f7f8"
        orientation="horizontal"
      >
        Избавьтесь от блокнотов - электронный календарь с наглядным расписанием
        записей, рабочих и личных задач
      </AdvantageCard>

      <div v-if="!isExpanded" class="d-md-none">
        <AppButton variant="outlined" fluid @click="isExpanded = true">
          Смотреть все
        </AppButton>
      </div>

      <AdvantageCard
        class="differences__long-block-2 d-md-block"
        :class="{ 'd-none': !isExpanded }"
        :icon-src="`${staticUrl}/landing/difference6.png`"
        title="Система рейтинга"
        color="#fcf5fc"
      >
        Создает честную конкуренцию среди мастеров. Чем выше рейтинг — тем
        больше доверия
      </AdvantageCard>

      <AdvantageCard
        class="d-md-block"
        :class="{ 'd-none': !isExpanded }"
        :icon-src="`${staticUrl}/landing/why3.png`"
        title="Исключительно мастера"
        color="#f2f3fc"
      >
        Размещение услуг только в сфере красоты. Без лишних специальностей,
        которые путают клиентов
      </AdvantageCard>

      <AdvantageCard
        class="d-md-block"
        :class="{ 'd-none': !isExpanded }"
        :icon-src="`${staticUrl}/landing/difference3.png`"
        title="Искренние отзывы"
        color="#f2f3fc"
      >
        Клиент может поставить оценку лишь после прохождение процедуры. Сервис
        напомнит ему об этом
      </AdvantageCard>

      <AdvantageCard
        class="differences__long-block-3 d-md-block"
        :class="{ 'd-none': !isExpanded }"
        :icon-src="`${staticUrl}/landing/difference2.png`"
        title="Все общение рядом"
        color="#fcf5fc"
      >
        Не упускай важные сообщения — теперь рабочие чаты со всеми клиентами в
        одном приложении.
      </AdvantageCard>
    </div>
  </div>
</template>

<style scoped lang="scss">
.differences {
  &__grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;

    @include media-breakpoint-down(md) {
      display: flex;
      flex-direction: column;
    }
  }

  &__long-block-1 {
    grid-column-start: 1;
    grid-column-end: 4;
  }

  &__long-block-2 {
    grid-column-start: 1;
    grid-column-end: 3;
  }

  &__long-block-3 {
    grid-column-start: 2;
    grid-column-end: 4;
  }
}
</style>
